import { msg } from '@lingui/core/macro';

export const CLIENT_FILTER_OPTIONS = [
  {
    id: 'yes' as const,
    label: msg({
      id: 'settings.organization.entities.agreements.filters.client.yes',
      message: 'Yes',
    }),
  },
  {
    id: 'no' as const,
    label: msg({
      id: 'settings.organization.entities.agreements.filters.client.no',
      message: 'No',
    }),
  },
];

export type ClientFilterId = (typeof CLIENT_FILTER_OPTIONS)[number]['id'];
